import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { Upload, List, Icon, Card } from "antd";
import {
    DragSource
    // DragPreviewImage
} from "react-dnd";
import { FILE_TYPE } from "constants/drag-drop-types";

import "styles/draggable-list.css";

const Dragger = Upload.Dragger;
const ListItem = List.Item;

const cardSource = {
    canDrag: props => !props.active,
    beginDrag: props => {
        return {
            fileName: props.document.file_name,
            fileUrl: props.document.url
        };
    },
    endDrag: (props, monitor) => {
        if (monitor.didDrop()) {
            props.onAttach(props.id, monitor.getDropResult());
        }
        return {
            fileName: props.document.file_name,
            fileUrl: props.document.url
        };
    }
};

/**
 * Specifies the props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        connect,
        monitor
    };
}

const ListItemChild = props => {
    return (
        <div className={"list-item-draggable d-flex flex-row"}>
            <div className="p-5">{}</div>
            <div className="p-5" ref={props.connect.dragSource()}>
                {props.document.file_name}
            </div>
            <div>{props.active ? <Icon type={"loading"} /> : null}</div>
        </div>
    );
};

ListItemChild.displayName = "ListItemChild";
ListItemChild.propTypes = {
    id: PropTypes.number,
    document: PropTypes.object,
    connect: PropTypes.object,
    onAttach: PropTypes.func,
    active: PropTypes.bool
};

const DraggableListItem = DragSource(FILE_TYPE, cardSource, collect)(
    ListItemChild
);

class MultipleFileUploader extends React.Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.list.size !== this.props.list.size) {
            return true;
        }
        return false;
    }
    fileUpload = false;
    /**
     * Specifies the previously uploaded list of files
     */
    get fileList() {
        return [];
    }
    /**
     *  Specifies the props needed for ant design upload component
     */
    get draggerProps() {
        return {
            directory: false, // Upload Directory Support
            multiple: true, // Upload Multiple files support
            showUploadList: false,
            beforeUpload: (file, fileList) => {
                if (!this.fileUpload) {
                    this.fileUpload = true;
                    this.props.uploadFiles(fileList);
                }
                return false;
            }
        };
    }
    /**
     * Filters list of files after each file has been
     * dragged and attached to a case
     */
    onFileAttach = (docId, document) => {
        this.props.onFilePick(
            this.props.list.find((_, i) => i === docId),
            document
        );
    };

    render() {
        const { list } = this.props;
        return (
            <Card className={cx("padless-card", "p-5")}>
                <div
                    className={cx("d-flex", "flex-column")}
                    style={{ height: "600px" }}
                >
                    <div style={{ height: "130px" }}>
                        <Dragger {...this.draggerProps}>
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag file to this area to upload
                            </p>
                        </Dragger>
                    </div>
                    <div
                        style={{
                            height: "calc(100% - 130px)",
                            overflow: "scroll"
                        }}
                    >
                        <List
                            itemLayout={"vertical"}
                            className={cx("f-grow-1")}
                        >
                            {list
                                .filter(_ => _.get("data"))
                                .map((_, id) => (
                                    <ListItem key={id} className={"px-5"}>
                                        <DraggableListItem
                                            document={_.get("data")}
                                            id={id}
                                            onAttach={this.onFileAttach}
                                        />
                                    </ListItem>
                                ))
                                .toList()
                                .toArray()}
                        </List>
                    </div>
                </div>
            </Card>
        );
    }
}

MultipleFileUploader.defaultProps = {};

MultipleFileUploader.propTypes = {
    list: PropTypes.object, // object type
    onFilePick: PropTypes.func,
    uploadFiles: PropTypes.func
};

export default MultipleFileUploader;
